class UserLogModel {
  _data = {
    userCode: String,
    CNPJ_CNPF: String,
    totemId: String,
    useDate:  String,
    smsTransaction: Boolean,
    emailTransaction: Boolean,
    paymenTransaction: Boolean, 
    printTransaction: Boolean,
    serviceTime: String,
    userLogId: String
  }

  constructor(data = {}) {
    this.setData(data)
  }

  setData (data) {
    this._data.userCode  = data.userCode || ''
    this._data.CNPJ_CNPF  = data.CNPJ_CNPF || ''
    this._data.totemId = data.totemId || ''
    this._data.useDate = data.useDate || ''
    this._data.smsTransaction = false
    this._data.emailTransaction = false
    this._data.paymenTransaction = false
    this._data.printTransaction = false
    this._data.serviceTime = data.serviceTime || ''
    this._data.userLogId = data.userLogId || ''
  }

  getData () {
    return this._data
  }

 
}

export default UserLogModel;